import VueTelInput from 'vue-tel-input';
import 'vue-tel-input/vue-tel-input.css';

export const registerVueTelInput = (app) => app.use(VueTelInput)